<div class="alert-page">
  <!-- 👁️ Banner modo visualização -->
  <div *ngIf="watchMode" class="watch-mode-banner">
    <span>👁️ MODO VISUALIZAÇÃO</span>
    <small>Somente observação - Alertas não são confirmados</small>
  </div>

  <app-alert-display
    [event]="event"
    [showMessage]="showMessage"
    [alertPosition]="alertPosition"
    [message]="message"
    [mainText]="mainText"
    [userMessage]="userMessage"
    [useSeparateTemplate]="isDonation"
    [alertVolume]="alertVolume"
    [stopSignal]="stopSignal"
    [voiceRecordingUrl]="voiceRecordingUrl"
    [streamerId]="streamerId"
    [donationId]="currentDonationId"
    [musicthonConfig]="musicthonConfig"
    (audioFinished)="onAudioFinished()"
  >
  </app-alert-display>
</div>
